import React, { useState } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import EmployeeTable from "../employees/components/EmployeeTable";
import FarmTable from "../farms/components/FarmTable";

const AccountTab = ({ recordId }) => {
  const location = useLocation();

  const pathParts = location.pathname.split("/").filter(Boolean);
  let lastSegment = pathParts[pathParts.length - 1];
  if(lastSegment === 'view'){
    lastSegment = 'farms';
  }
  const [activeTab, setActiveTab] = useState(lastSegment);

  const items = [
    { key: "farms", label: "Farms", children: <FarmTable accountId={recordId} /> },
    { key: "employees", label: "Employees", children: <EmployeeTable accountId={recordId} /> },
  ];

  const onChange = (key) => {
    setActiveTab(key);
  };

  return <Tabs type="card" activeKey={activeTab} onChange={onChange} items={items} />;
};

export default AccountTab;
